import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  site: "Aura Credit",
  image: "https://aura-credit.app/og-image.png",
  twitter: "@auracredit",
};

/**
 * Reusable SEO tag block — pass title/description/path and it emits all the
 * standard <meta> + Open Graph + Twitter Card tags Google + social crawlers use.
 */
export function SEO({
  title,
  description,
  path = "",
  image = DEFAULTS.image,
  type = "website",
  keywords,
  noindex = false,
}) {
  const url = `https://aura-credit.app${path}`;
  const fullTitle = title ? `${title} · ${DEFAULTS.site}` : DEFAULTS.site;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:site_name" content={DEFAULTS.site} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={DEFAULTS.twitter} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
